<template>
    <div class="jd-pub-expert" v-if="status === CONST.ORDER_STATUS_CREATE">
        <div class="k-cell">
            <div v-if="appraiserList">
                <span v-if="!myAppraiser">您心仪的老师不符合，</span>
                <span>为您找到 </span>
                <span class="cl-red">{{appraiserList.length+(myAppraiser?1:0)}}</span> 位 <span class="cl-red">{{getKey.name}}</span> 鉴定老师，点击〇选择老师帮您鉴定
            </div>
            <div v-if="appraiserList && !appraiserList.length">没有查询到相关鉴定专家</div>
        </div>
        <div v-if="myAppraiser">
            <appraiser-item :info="myAppraiser">
                <div slot="select">
                    <k-radio-group v-model="selectType">
                        <k-cell v-if="myAppraiser.fast"><k-radio :name="myAppraiser.aid+'-2-'+myAppraiser.fast" checked-color="#CEA065">极速鉴定 <small>8小时内完成 否则全额退款</small> <span class="fl-right">¥{{myAppraiser.fast|fen2yuan}}</span> </k-radio></k-cell>
                        <k-cell v-if="myAppraiser.slow"><k-radio :name="myAppraiser.aid+'-1-'+myAppraiser.slow" checked-color="#CEA065">普通鉴定 <small>24小时内完成 否则全额退款</small> <span class="fl-right">¥{{myAppraiser.slow|fen2yuan}}</span> </k-radio></k-cell>
                    </k-radio-group>
                </div>
            </appraiser-item>
            <k-hr/>
        </div>
        <div v-if="appraiserList && appraiserList.length">
            <div v-for="(item,index) in appraiserList" :key="item.aid">
                <appraiser-item :info="item">
                    <div slot="select">
                        <k-radio-group v-model="selectType">
                            <k-cell v-if="item.fast"><k-radio :name="item.aid+'-2-'+item.fast" checked-color="#CEA065">极速鉴定 <small>8小时内完成 否则全额退款</small> <span class="fl-right">¥{{item.fast|fen2yuan}}</span> </k-radio></k-cell>
                            <k-cell v-if="item.slow"><k-radio :name="item.aid+'-1-'+item.slow" checked-color="#CEA065">普通鉴定 <small>24小时内完成 否则全额退款</small> <span class="fl-right">¥{{item.slow|fen2yuan}}</span> </k-radio></k-cell>
                        </k-radio-group>
                    </div>
                </appraiser-item>
                <k-hr/>
            </div>
        </div>
        <div v-else class="k-nodata">
            暂无数据
        </div>
        <div class="jd-fixed-btns">
            <k-row class="jd-pub-expert--tip">
                <k-col span="16">
                    <div class="jd-pub--expert-text">
                        <span v-if="price">鉴定费¥{{price|fen2yuan}}</span>
                        <span v-else>还未选择专家</span>
                    </div>
                </k-col>
                <k-col span="8"><k-button type="primary" block @click="submit" :disabled="!isOk">提交申请</k-button></k-col>
            </k-row>
        </div>
    </div>
</template>

<script>
    import {mapGetters,mapActions, mapState} from "vuex"
    import {jiandingStepChoose} from "../../api/jianding"
    export default {
        name: "pub-expert-list",
        data() {
            return {
                orderId : this.$route.query.orderId || 0,
                tabid : this.$route.query.tabid || 0,
                aid : this.$route.query.aid || 0,
                type : 0, //鉴定类型 鉴定类型 1 普通 2快速
                price : 0, //鉴定类型 鉴定类型 1 普通 2快速
                selectType : "",
                key : "",
                list : [1,2],
                isOk : false,
                status : 0
                //appraises:{name:"许水献", tags:['玉翠珠宝','钱币','字画'], logo:"https://imgcdn-prd.pydp888.com/3/product/70/120343k3acz7ah4oaevak1.jpg.1.thumb.jpg"}
            }
        },
        computed : {
           ...mapGetters("jianding", ["getAppraisers", "getTabs", "CONST"]),
            getKey(){
               return this.getTabs(this.tabid) || ""
            },
            myAppraiser(){
                return this.getAppraisers('my')
            },
            appraiserList(){
               return this.getAppraisers()
            },
            selectText(){
               let {price} = this;
               return price ? `鉴定费¥${price}`:'还未选择专家'
            }
        },
        methods:{
            ...mapActions("jianding", ["loadAppraisers", "makeOrder", "goCash", "loadOrderDetail"]),
            async submit(){
                let {aid, type, orderId} = this;
                let query = {aid, type, orderId};
                if(this.ckQuery()){
                    console.log(JSON.stringify(query, null, 2));
                    await jiandingStepChoose(query).then(R=>{
                        this.$toast.success("申请鉴定成功，正在转到支付");
                        setTimeout(()=>{
                            /*this.$router.replace({
                                path : '/my/order'
                            })*/
                            this.toPay();
                        },2000)
                    }).catch(err => {
                        this.$toast(err.message)
                    });


                }
            },
            async toPay() {
                if (!this.orderId) {
                    this.$toast("订单ID有误");
                    return
                }
                await this.makeOrder({orderId: this.orderId}).then(R => {

                }).catch(err => {
                    this.$toast(err.message)
                })

            },
            ckQuery(){
                let {aid, type, orderId} = this;
                if(!aid || !type){
                    this.$toast("请选择服务");
                    return false
                }
                if(!orderId){
                    this.$toast("订单ID有误，请核实");
                    return false
                }
                return true
            },
            getAps(){

            }
        },
        async created() {
            let {orderId, tabid, CONST} = this;
            const R = await this.loadOrderDetail({id:orderId});
            let { status } = R.detail || {};
            this.status = status || 0;
            if(status > CONST.ORDER_STATUS_CREATE){
                this.$dialog.alert({
                    title: '温馨提示',
                    message: '请返回订单列表确认订单是否已经支付'
                }).then(()=>{
                   this.$router.push({
                       path: '/my/order?tab=4&page=1'
                   })
                });
                return
            }
            await this.loadAppraisers({orderId, tabid})
        },
        watch: {
            selectType(nv){
                if(nv){
                    let arr = nv.split("-");
                    this.aid = arr[0] || 0;
                    this.type = arr[1] || 0;
                    this.price = arr[2] || 0;
                }
                this.$emit("select", {appraiser:nv})
                this.isOk = true
            }
        }
    }
</script>

<style scoped>

</style>